import React from 'react';

import { cn } from 'utils/global';

interface TableItemProps {
  tableName: string;
  selectedColumns: number;
  totalColumns: number;
  isSelected: boolean;
  onSelect: () => void;
}

const TableItem: React.FC<TableItemProps> = ({ tableName, selectedColumns, totalColumns, isSelected, onSelect }) => {
  return (
    <li
      className={cn(
        'flex justify-between items-center p-2 rounded cursor-pointer hover:bg-neutral-50 dark:hover:bg-neutral-900',
        {
          '!bg-primary-50 border-primary-500': isSelected,
        }
      )}
      onClick={onSelect}
    >
      <div className="flex items-center gap-2">
        <div
          className={cn('w-5 h-5 rounded-full border-2 border-neutral-200 dark:border-neutral-800 duration-150', {
            '!bg-primary-500 !border-primary-500': isSelected,
          })}
        />
        <span
          className={cn('text-neutral-900 dark:text-neutral-100', {
            '!text-primary-500': isSelected,
          })}
        >
          {tableName}
        </span>
      </div>
      <span
        className={cn('text-neutral-900 dark:text-neutral-100', {
          '!text-primary-500': isSelected,
        })}
      >
        {selectedColumns} out of {totalColumns} selected
      </span>
    </li>
  );
};

export default TableItem;
